<template>
  <div>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item v-show="contextMenu.TASKTYPE == 'E9354DE41375'" @click="open()">打开</v-contextmenu-item>
      <v-contextmenu-item
        v-clipboard:copy="contextMenu.TASKNAME"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >复制名称</v-contextmenu-item>
      <v-contextmenu-item @click="handleFolderMenuClick()">详情</v-contextmenu-item>
      <v-contextmenu-item @click="workRecordDetail()">查看工作记录</v-contextmenu-item>
      <v-contextmenu-item @click="createdTalk">发起会话</v-contextmenu-item>
      <v-contextmenu-item @click="urgeTask">催办</v-contextmenu-item>
      <v-contextmenu-item @click="addWorkRecord">添加工作记录</v-contextmenu-item>
      <v-contextmenu-item @click="addTaskTag">设置标签</v-contextmenu-item>
      <!-- <v-contextmenu-item @click="Notification">通知详情</v-contextmenu-item> -->
      <!--contextMenu.MYFOCUSED ? "取消收藏" : "设置收藏"-->
      <v-contextmenu-item @click="setConstTask">{{ "设置收藏" }}</v-contextmenu-item>
      <v-contextmenu-item divider></v-contextmenu-item>
      <v-contextmenu-item @click="add()">添加到</v-contextmenu-item>
      <!--v-if="contextMenu.TASKTYPE === 'E9354DE41375'"-->
      <!-- <v-contextmenu-item @click="TaskSummary">任务总结</v-contextmenu-item> -->
    </v-contextmenu>
    <SideTagsRecordDialog ref="SideTagsRecordDialog"></SideTagsRecordDialog>
    <SelectTaskChatSession ref="selectTaskChatSession"></SelectTaskChatSession>
    <taskListDialog ref="taskListDialog"></taskListDialog>
    <workRecordDialog ref="workRecordDialog" :taskIds="taskIds"></workRecordDialog>
    <taskDialog ref="taskRelationDialog" :isGroup="true" @getValue="getTask"></taskDialog>
    <TagSelect ref="tagSelect" :tagIds="tagIds" :showFootButton="true" @success="saveTag"></TagSelect>
    <collectDialog
      :taskName="contextMenu.TASKNAME"
      :taskContextMenu="contextMenu"
      ref="collectDialog"
    ></collectDialog>
  </div>
</template>

<script>
import TagSelect from "./Tag/TagSelect.vue";
// import SideTagsRecordDialog from "../components/SideTagsRecordDialog.vue";
import SelectTaskChatSession from "../Chat/SelectTaskChatSession.vue";
import taskListDialog from "../components/taskListDialog.vue";
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
import workRecordDialog from "../taskGroup/workRecordDialog.vue";
import collectDialog from "./collectDialog.vue";

import { AllChildNode } from "@/api/modules/basicData/commonData";
import { mapState } from "vuex";
import folder from "@/api/modules/basicData/folder";
import { ConstTask, SaveTaskTags } from "@/api/modules/basicData/task";
import { GetSubTaskTreePathByTaskId } from "@/api/modules/basicData/basicTask";
export default {
  data() {
    return {
      taskIds: [],
    };
  },
  props: {
    contextMenu: {
      type: Object,
      default: () => {},
      require: true,
    },
    props: {
      isTask: {
        type: Boolean,
        default: true,
      },
    },
  },
  methods: {
    saveTag(values) {
      var tags = values.map((value) => {
        return {
          TASKID: this.contextMenu.ID,
          TAGID: value.ID,
          COLOR: value.COLOR,
          TAGNAME: value.TAGNAME,
          CREATEUSERID: value.CREATEUSERID,
          CREATEUSERNAME: value.CREATEUSERNAME,
          CREATEDEPTID: value.CREATEDEPTID,
          CREATEDEPTNAME: value.CREATEDEPTNAME,
          CREATECOMPANYID: value.CREATECOMPANYID,
          CREATECOMPANYNAME: value.CREATECOMPANYNAME,
        };
      });
      SaveTaskTags(tags, this.contextMenu.ID).then((result) => {
        if (result.ResultCode > 0) {
          this.$store.dispatch("changeTaskSource");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    addTaskTag() {
      if (!this.contextMenu) {
        this.$message.warning("请选中一行");
        return;
      }
      console.log("contextMenu", this.contextMenu);
      this.$refs.tagSelect.dialogVisible = true;
    },
    Show(postition) {
      //显示右键菜单
      this.$refs.contextmenu.show(postition);
    },
    setConstTask() {
      console.log("contextMenu", this.contextMenu);
      this.$refs.collectDialog.openDialog();
      // ConstTask(
      //   this.contextMenu.MYFOCUSED,
      //   this.userId,
      //   this.contextMenu.ID
      // ).then(result => {
      //   if (result.ResultCode > 0) {
      //     this.$message.info(
      //       this.contextMenu.MYFOCUSED ? "取消收藏成功" : "设置收藏成功"
      //     );
      //     this.contextMenu.MYFOCUSED = !this.contextMenu.MYFOCUSED;
      //   } else {
      //     this.$message.error(resultCode.MsgInfo);
      //   }
      // });
    },
    createdTalk() {
      //	alert("createdTalk" + this.contextMenu.TASKNAME)
      this.$refs.selectTaskChatSession.initialSource(this.contextMenu.ID);
    },
    urgeTask() {
      // alert("urgeTask" + this.contextMenu.TASKNAME)
      this.$prompt("请输入催办内容", "催办任务", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        if (!value) {
          this.$message.info("请输入催办内容");
          return false;
        } else if (!this.trim(value)) {
          this.$message.info("请输入催办内容");
          return false;
        }
        urgeTask(this.contextMenu.ID, value, this.userId).then((resultCode) => {
          if (resultCode) {
            this.$message.success("催办成功");
          } else {
            this.$message.error("催办失败");
          }
        });
      });
    },
    addWorkRecord() {
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.addRecordRelation(
        this.contextMenu.ID,
        this.contextMenu.TASKNAME,
        0,
        this.contextMenu.INSTANCE
      );
    },
    Notification() {
      this.$refs.taskListDialog.dialogVisible = true;
    },
    add() {
      this.$store.commit("setSelectTaskList", [this.contextMenu]);
      this.$refs.taskRelationDialog.dialogVisible = true;
    },
    TaskSummary() {
      //打开总结
      if (this.contextMenu.EXCUTEUSERID != this.userId) {
        this.$message({
          message: "请选择自己执行的任务进行总结",
          type: "warning",
        });
      } else {
        if (this.contextMenu.STATE == 1 || this.contextMenu.STATE == 2) {
          if (this.contextMenu.HasSummary == false) {
            if (this.contextMenu.STATE == 1) {
              this.submitBtn = "保存草稿";
            } else {
              this.submitBtn = "提交";
            }
            let dds = "";
            if (
              this.contextMenu.CONTENT != null &&
              this.contextMenu.CONTENT != ""
            ) {
              let dd = this.contextMenu.CONTENT.replace(/<\/?.+?>/g, "");
              dds = dd.replace(/ /g, ""); //dds为得到后的内容
            }
            this.myRowData.Complete = false;
            this.myRowData.taskState = this.contextMenu.STATE;
            this.myRowData.taskId = this.contextMenu.ID;
            this.myTaskCode = this.contextMenu.INSTANCE;
            this.myTaskName = this.contextMenu.TASKNAME;
            this.myRowData.taskDescreption = dds;
            this.myRowData.taskName = this.contextMenu.TASKNAME;
            this.myRowData.userId = this.userId;
            this.submitDis = false;
            this.summaryTaskDialogVisible = true;
          } else {
            getAllTaskSummaryByTaskId(this.contextMenu.ID).then((res) => {
              this.allSummary = res;
              this.allSummaryVisible = true;
            });
          }
        } else {
          this.$message({
            message: "当前任务状态无法总结",
            type: "warning",
          });
        }
      }
    },
    openBlank(taskid) {
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: {
          taskid: taskid,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    open() {
      this.dbclick(this.contextMenu);
    },
    onCopy(e) {
      this.$message.success("复制成功！");
    },
    onError(e) {
      this.$message.error("复制失败！");
    },
    workRecordDetail() {
      this.taskIds = AllChildNode(this.contextMenu, "ID");
      console.log("workRecordDetail", this.taskIds);
      this.$refs.workRecordDialog.OpenDialog(this.taskIds);
    },
    handleFolderMenuClick() {
      // 任务详情不提交store
      if (this.isTask) {
        this.$store.dispatch("changeCurTask", this.contextMenu);
      }
      this.openBlank(this.contextMenu.ID);
    },
    dbclick(row) {
      //双击行事件
      if (row.TASKTYPE == "E9354DE41375") {
        // this.$store.commit("setTaskGroupCurrents", row.ID);
        this.GetSubTaskTreePathByTaskId(row.ID, row);
      } else {
        // 任务详情不提交store
        if (this.isTask) {
          this.$store.dispatch("changeCurTask", row);
        }
        this.openBlank(row.ID);
      }
    },
    GetSubTaskTreePathByTaskId(taskId, row) {
      GetSubTaskTreePathByTaskId(taskId, this.userId).then((result) => {
        if (result.length > 0) {
          this.$store.commit("setTaskGroupCurrentData", {
            taskGroupCurrent: result,
            row: row,
          });
        } else {
          this.$store.commit("setTaskGroupCurrentData", {
            taskGroupCurrent: [],
            row: row,
          });
        }
      });
    },
    getTask(arr) {
      console.log("arr", arr);
      let folderList = [];
      let dt = new Date();
      // arr.forEach(item => {
      //     folderList.push({
      //         NODEID: 0,
      //         NODETYPE: item.TASKTYPE == "E9354DE41375" ? 3 : 0,
      //         NODENAME: item.TASKNAME + "(" + item.INSTANCE + ")",
      //         CREATETIME: dt,
      //         // PNODEID: this.parentInfo.NODEID,
      //         // PNODENAME: this.parentInfo.NODENAME,
      //         // PNODETYPE: this.parentInfo.NODETYPE,
      //         RELATIONID: item.ID,
      //         RELATIONCREATETIME: new Date(item.CREATETIME),
      //         RELATIONTYPE: item.STATE,
      //         RELATIONTYPENAME: item.TASKSTATENAME,
      //         CREATEUSERID: this.userId,
      //         CREATEUSERNAME: this.userName,
      //         CHILDRENCOUNT: 0
      //     });
      // });

      let item = this.contextMenu;
      folderList.push({
        NODEID: 0,
        NODETYPE: item.TASKTYPE == "E9354DE41375" ? 3 : 0,
        NODENAME: item.TASKNAME,
        CREATETIME: dt,
        // PNODEID: this.parentInfo.NODEID,
        // PNODENAME: this.parentInfo.NODENAME,
        // PNODETYPE: this.parentInfo.NODETYPE,
        RELATIONID: item.ID,
        RELATIONCREATETIME: new Date(item.CREATETIME),
        RELATIONTYPE: item.TASKTYPE,
        RELATIONTYPENAME: item.TASKTYPENAME,
        CREATEUSERID: this.userId,
        CREATEUSERNAME: this.userName,
        CHILDRENCOUNT: 0,
      });

      if (folderList.length > 0) {
        folder.InsertTaskIntoFolder(folderList, arr[0].ID, 3).then((res) => {
          if (res.ResultCode == 1) {
            this.$store.dispatch("changeTaskSource");
          } else {
            this.$message.error({
              message: "错误，请重试",
              center: true,
            });
          }
        });
      }
    },
  },
  components: {
    collectDialog,
    // SideTagsRecordDialog: () =>
    //   import("../components/SideTagsRecordDialog.vue"),
    // taskDialog: () =>
    //   import("@/components/basicTemplate/common/taskDialog.vue"),
    SelectTaskChatSession,
    taskListDialog,
    TagSelect,
    workRecordDialog,
  },
  computed: {
    ...mapState({
      curTask: (state) => state.task.curTask,
      taskcontextMemu: (state) => state.task.taskcontextMemu,
      userId: (state) => state.task.userId,
      userName: (state) => state.task.realName,
      viewType: (state) => state.task.viewType,
      taskGroupCurrent: (state) => state.task.taskGroupCurrent,
    }),
    tagIds() {
      return this.contextMenu.TagList != undefined &&
        this.contextMenu.TagList != null
        ? this.contextMenu.TagList.map((o) => o.TAGID)
        : [];
    },
    computedCurRowType() {
      let row = this.contextmenuRow;
      let typelist = this.TaskType.filter((item) => item.ID == row.TASKTYPE);
      if (typelist.length > 0) {
        return row.childrens ? true : false; //typelist[0].REMARK
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
</style>
